import React, {FC, ReactNode, useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Link from "next/link";
import {BlogSVG, CategorySVG, ContactusSVG, TrackingSVG} from "../../../../../svg";
import {IState} from "../../../../../types/state";
import {mobileMenuClose} from "../../../../../store/mobile-menu";
import cls from "./customMobileMenu.module.scss"
import CustomMobileLinks from "./CustomMobileLinks";
import CustomCurrDropDown from "../../CustomCurrDropDown";
import CustomMobileMenuFooter from "./CustomMobileMenuFooter";
import {ICustomMobileMenu} from "../../MainLayout";
import {domainUrl} from "../../../../../helper";
import {useRouter} from "next/router";

interface ILinkItems {
    linkHref: string,
    key_INTL: string,
    svg: ReactNode
}

const LinksItems: FC<ILinkItems> = (
    {
        linkHref,
        key_INTL,
        svg
    }
) => {
    const dispatch = useDispatch();
    return (
        <ul className={cls["mob-links__item"]}>
            <Link href={linkHref}>
                <a onClick={() => dispatch(mobileMenuClose())}>
                    <span className={cls["mobile-links__blok"]}>{svg}{key_INTL}</span>
                </a>
            </Link>
        </ul>
    )
};

const CustomMobileMenu: FC<ICustomMobileMenu> = (
    {
        menus,
        categories,
        blogValue,
        salesActiveSettings: {
            Tracking = "",
            ContactWithUs = ""
        } = {},
        translationsData,
        currencies: [{
            code: selectedCurr = "",
            symbol: selectedSymbol = ""
        } = {}, ...currencies] = [],
        phoneValue,
        footerAddressValue,
        footerEmailValue,
        socialsFooter,
        dbName,
        showMobileContactsStyle,
        showMobileSocialsStyle,
        mobileMenuPagesToggle,
        selectedLocaleImg,
        locales = [],
        domain
    }
) => {
    const dispatch = useDispatch();
    const {asPath, ...router} = useRouter();
    const langRef = useRef<HTMLDivElement | null>(null);
    const mobileMenuOpen = useSelector((state: IState) => state.mobileMenu.open);

    useEffect(() => {
        const handleEvent = () => {
            dispatch(mobileMenuClose())
        }

        // TODO!!! unload change into pagehide for CWV improvement, remove if it does not work
        // window.addEventListener("unload", handleEvent)
        //
        // return () => window.removeEventListener('unload', handleEvent)
        window.addEventListener("pagehide", handleEvent);

        return () => {
            window.removeEventListener("pagehide", handleEvent);
        };
    }, []);

    useEffect(() => {
        if (mobileMenuOpen) {
            document.body.classList.add('menu-open');
        } else {
            document.body.classList.remove('menu-open');
        }

        return () => document.body.classList.remove('menu-open');
    }, [mobileMenuOpen]);

    useEffect(() => {
        const handleClick = (e: MouseEvent) => {
            if (langRef && langRef.current && !langRef.current.contains(e.target as Node)) {
                setOpenLang({langMenuClassName: "none", langDDAClassName: ""})
            }
        }

        document.addEventListener("mousedown", (e) => {
            handleClick(e);
        })

        return () => document.removeEventListener("mousedown", (e) => {
            handleClick(e)
        })
    }, [langRef])

    const classNamesHandler = {
        "true": cls["mobilemenu--open"],
        "false": ""
    }
    const hasElement: (attributes: { linkHref: string; key_INTL: string; svg: ReactNode })
        => Record<string, ReactNode> = (attributes) => {
        return {
            "true": <LinksItems {...attributes} />,
            "false": null
        }
    }

    const handleCurrencyDropdown = {
        true: <CustomCurrDropDown
            selectedSymbol={selectedSymbol}
            selectedCurr={selectedCurr}
            currencies={currencies}
        />,
        false: null
    }

    const hasCategory = {
        "true": <CustomMobileLinks
            links={[{label: "Cat", children: categories}]}
            onItemClick={() => dispatch(mobileMenuClose())}
            labelRender={categories[0]?.name}
            svgRender={<CategorySVG/>}
            dbName={dbName}
            domain={domain}
        />,
        "false": null
    }


    const [
        {langMenuClassName, langDDAClassName},
        setOpenLang
    ] = useState({langMenuClassName: "none", langDDAClassName: ""});

    const handleLangClick = () => {
        setOpenLang(({langMenuClassName}) => {
            if (langMenuClassName === "none") {
                return {
                    langMenuClassName: "block",
                    langDDAClassName: "rotT_fms"
                }
            }
            return { langMenuClassName: "none", langDDAClassName: ""}
        })
    }

    return <div className={`${cls["mobilemenu"]} ${classNamesHandler[`${mobileMenuOpen}`]}`}>
        <div className={cls.mobilemenu__backdrop} onClick={() => dispatch(mobileMenuClose())}/>
        <div className={cls.mobilemenu__body}>
            <div className={cls.mobilemenu__content}>
                {hasCategory[`${!!categories.length}`]}
                <div className={`${cls.mobilemenu__menus}`}>
                    {menus.map((item: any, index) => {
                        const {name, frontLink, target = {}} = item
                        return (
                            <div key={index} className={cls.menu}>
                                <Link href={frontLink as string}>
                                    <a
                                        rel="noopener noreferrer"
                                        {...target}
                                        className={cls["menu-link__item-link"]}
                                        onClick={() => dispatch(mobileMenuClose())}
                                    >
                                        {name}{' '}
                                    </a>
                                </Link>
                            </div>
                        )
                    })}
                </div>
                {
                    hasElement({
                        linkHref: "/posts",
                        key_INTL: translationsData?.Posts,
                        svg: <BlogSVG/>
                    })[`${!!+blogValue}`]
                }
                {
                    hasElement({
                        linkHref: "/contactwithus",
                        key_INTL: translationsData?.ContactWithUs,
                        svg: <ContactusSVG/>
                    })[`${!!(+ContactWithUs)}`]
                }
                {
                    hasElement({
                        linkHref: "/tracking",
                        key_INTL: translationsData?.Tracking,
                        svg: <TrackingSVG/>
                    })[`${!!(+Tracking)}`]
                }
            </div>
            <div className={cls.mobilemenu_buttons}>
                {locales.length ? (
                    <div id="forLanguage" className={`${cls["language-button"]} ${cls["locale-bttn"]}`} onClick={handleLangClick} ref={langRef}>
                        {locales?.map(({code, id, locale_image, selected = false}) => {
                            if (selected) {
                                return (
                                    <span className={cls.selected_locale}>
                                                <img src={domainUrl(`${dbName}${selectedLocaleImg}`)} alt="Language" loading="lazy"/>
                                            </span>
                                )
                            }
                            return (
                                <Link href={asPath} locale={code} key={id}>
                                    <a className={cls.menu_item}>
                                        <img src={domainUrl(`${dbName}${locale_image}`)} alt="Language" loading="lazy"/>
                                    </a>
                                </Link>
                            )
                        })}
                    </div>
                ) : null}
                {handleCurrencyDropdown[`${!!currencies.length}`]}
            </div>
            <CustomMobileMenuFooter
                phoneValue={phoneValue}
                footerAddressValue={footerAddressValue}
                footerEmailValue={footerEmailValue}
                socialsFooter={socialsFooter}
                dbName={dbName}
                translationsData={translationsData}
                showMobileContactsStyle={showMobileContactsStyle}
                showMobileSocialsStyle={showMobileSocialsStyle}
            />
        </div>
    </div>
};


export default CustomMobileMenu
